var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Wrapper"},[_c('h5',[_vm._v("Already have a font?")]),_c('router-link',{attrs:{"to":{ name: 'ProjectImport', params: { id: _vm.projectId } }}},[_vm._v("Import icons")]),_vm._v(" from existing font ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }